export default "__VITE_ASSET__CSJe5mef__"